module.exports = __webpack_public_path__ + "img/btn_menu_order.5e907277.svg";